import { AboutStyled } from "./About.styled";
import AboutHero from "./aboutHero/AboutHero";
import Images from "./images/Images";
import Details from "./details/Details";

export default function About() {
    return (
        <AboutStyled>
            <AboutHero />
            <Images />
            <Details />
        </AboutStyled>
    );
}
